import { yupLocalized } from "@ryde/shared";

export interface IImportAreasForm {
  geoAreasIds: number[];
}

export const importAreasValidationSchema = {
  geoAreasIds: yupLocalized.array().min(1).of(yupLocalized.number().required()),
};
